import { application } from "./application"

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import SourceRowsController from "./source_rows_controller"
application.register("source-rows", SourceRowsController)

import ResourceFilterController from "./resource_filter_controller"
application.register("resource-filter", ResourceFilterController)

import TagPickerController from "./tag_picker_controller"
application.register("tag-picker", TagPickerController)

import ToolPickerController from "./tool_picker_controller"
application.register("tool-picker", ToolPickerController)

import TextareaAutogrowController from "./textarea_autogrow_controller"
application.register("textarea-autogrow", TextareaAutogrowController)

import WorkflowInputSelectController from "./workflow_input_select_controller"
application.register("workflow-input-select", WorkflowInputSelectController)

import AgentWorkflowTargetsController from "./agent_workflow_targets_controller"
application.register("agent-workflow-targets", AgentWorkflowTargetsController)

import AgentWorkflowFormController from "./agent_workflow_form_controller"
application.register("agent-workflow-form", AgentWorkflowFormController)

import AgentWorkflowAudienceController from "./agent_workflow_audience_controller"
application.register("agent-workflow-audience", AgentWorkflowAudienceController)

import AgentWorkflowRoutingController from "./agent_workflow_routing_controller"
application.register("agent-workflow-routing", AgentWorkflowRoutingController)

import AgentWorkflowScheduleController from "./agent_workflow_schedule_controller"
application.register("agent-workflow-schedule", AgentWorkflowScheduleController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import LandingController from "./landing_controller"
application.register("landing", LandingController)

import TreeToggleController from "./tree_toggle_controller"
application.register("tree-toggle", TreeToggleController)

import InboxPaneController from "./inbox_pane_controller"
application.register("inbox-pane", InboxPaneController)

import InboxChatController from "./inbox_chat_controller"
application.register("inbox-chat", InboxChatController)

import FilterDropdownController from "./filter_dropdown_controller"
application.register("filter-dropdown", FilterDropdownController)

import OwnerSelectController from "./owner_select_controller"
application.register("owner-select", OwnerSelectController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import CitationsController from "./citations_controller"
application.register("citations", CitationsController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DiscussionComposerController from "./discussion_composer_controller"
application.register("discussion-composer", DiscussionComposerController)

import DetailsController from "./details_controller"
application.register("details", DetailsController)
